import type { ValueOf } from '@shared/lib'

export const PaginationSize = { default: 'default', mobile: 'mobile' } as const
export type PaginationSize = ValueOf<typeof PaginationSize>
